import { z } from "zod"
import {
  MONTHLY_PERIODICITY,
  YEARLY_PERIODICITY,
} from "../consts/subscriptions"

export const SubscriptionPeriodicity = z.enum([
  MONTHLY_PERIODICITY,
  YEARLY_PERIODICITY,
])

export type SubscriptionPeriodicity = z.infer<typeof SubscriptionPeriodicity>
